// features/module-master.fields.js

import { MODULE_BADGES } from "layouts/SidebarBadge";
import { hasSubModules, isParentModule, parentFlagChanges } from "./module-master.parent";

// The path is shown next to the name to tell apart modules that share a name.
export const parentModuleLabel = (opt) => (opt.path && opt.path !== "#" ? `${opt.name} (${opt.path})` : opt.name);

export const moduleMasterFields = [
  {
    name: "name",
    label: "Module Name",
    type: "text",
    required: true,
    maxLength: 60,
  },
  {
    name: "is_parent",
    label: "Is Parent Module",
    type: "boolean",
    uiType: "toggle",
    defaultValue: false,
    wrapperClassName: "flex gap-2 justify-start items-center",
    // Not stored: worked out from the saved module (see module-master.parent.js).
    editValue: (record, { modules }) => isParentModule(record, modules),
    onValueChange: (value, formData, { modules }) => parentFlagChanges(value, formData, modules),
    // A module with sub-modules has to stay a parent.
    isReadOnly: (formData, { modules }) => hasSubModules(formData.id, modules),
    hint: (formData, { modules }) =>
      hasSubModules(formData.id, modules)
        ? "It has sub-modules, so it stays a parent."
        : "A parent groups sub-modules in the sidebar and has no path of its own.",
  },
  {
    name: "parent_fid",
    label: "Parent Module",
    type: "select",
    required: false,
    optionsKey: "parentModules",
    optionLabel: "name",
    optionLabelFormatter: parentModuleLabel,
    is_api_data: true,
    isClearable: true,
    // Parents sit at the top level. Leave empty for a top-level page.
    hidden: (formData) => !!formData.is_parent,
  },
  {
    name: "path",
    label: "Path",
    type: "text",
    required: true,
    hint: "e.g. /swiftboard/settings",
    // A parent has no page of its own; it's saved with "#".
    hidden: (formData) => !!formData.is_parent,
  },
  {
    name: "icon",
    label: "Icon (lucide name, e.g. LayoutDashboard)",
    type: "text",
    required: false,
  },
  {
    name: "badge",
    label: "Sidebar Badge",
    type: "select",
    required: false,
    is_enums_data: true,
    enums: MODULE_BADGES,
    isClearable: true,
  },
];
